import type { ReactNode } from 'react';

import styles from './ActivityModal.module.css';

import { visuallyHidden } from '../../styles';
import { ActivityIndicator } from '../ActivityIndicator';
import type { LightboxProps } from '../Lightbox';
import { Lightbox } from '../Lightbox';
import { Text } from '../Text';

export interface ActivityModalProps extends Pick<
  LightboxProps,
  'isOpen' | 'onClose' | 'aria-label'
> {
  /** The loading text to display in the modal. */
  text?: ReactNode;
}

/**
 * Display an {@link ActivityIndicator} in a modal persisting on the screen.
 *
 * @see https://corgi-x.tfd.engineering/components/activitymodal
 */
export function ActivityModal(props: ActivityModalProps) {
  return (
    <Lightbox
      aria-label={props['aria-label']}
      width=""
      height={0}
      contentClassName={styles['loading-modal']}
      isOpen={props.isOpen}
      onClose={props.onClose}
      closeOnBackdropClick={false}
    >
      {props.text && (
        <Text
          as="p"
          vSpacing="md"
          variant="heading-22"
          style={{ textAlign: 'center' }}
        >
          {props.text}
        </Text>
      )}
      <ActivityIndicator color="carrot" />
      {/* Required by the lightbox focusTrap */}
      <button className={visuallyHidden} aria-hidden />
    </Lightbox>
  );
}
